import { Component } from '@angular/core';

@Component({
  selector: 'sm-pay-via-paypal',
  templateUrl: './pay-via-paypal.component.html',
  styleUrls: ['./pay-via-paypal.component.scss']
})
export class PayViaPaypalComponent {

}
